import { AxiosInstance } from 'axios';
import { AttachmentEndpoints, GetAttachmentResponse } from './AttachmentServices.types';

export class AttachmentServices implements AttachmentEndpoints {
  instance: AxiosInstance;
  constructor(instance: AxiosInstance) {
    this.instance = instance;
  }

  getAttachments(guid: string) {
    return this.instance.get<GetAttachmentResponse>(`order/${guid}/attachments`);
  }
}
